module.exports = __webpack_public_path__ + "img/ssyx_17.03c0c46b.jpg";